import { CountryCode } from 'signup-ui-lego-core/constants/CountryCode';
import { getCountryCode } from '../store/app/selectors';
export const getIsJapan = state => {
  const country = getCountryCode(state);
  return CountryCode.Japan === country;
};